import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { UnsubscribeOnDestroy } from '../../classes';

@Component({
    selector: 'inactive',
    templateUrl: './inactive.component.html',
    styleUrls: ['./inactive.component.scss'],
    standalone: true
})
export class InactiveComponent extends UnsubscribeOnDestroy implements OnInit {
    private route = inject(ActivatedRoute);
    marketName: string;

    constructor() {
        super();

        this.route.queryParams
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(params => {
                this.marketName = params["marketName"];
            });
    }

    ngOnInit(): void { }
}
